import {
  type BaseOverlay,
  type BaseOverlayOptions,
  createBaseOverlay,
  createOverlay,
} from '@/shared/lib'

export type RegionOverlayProps = Omit<BaseOverlayOptions, 'map' | 'position'>

type RegionOverlayOptions = BaseOverlayOptions & RegionOverlayProps

export type RegionOverlay = BaseOverlay

export const createRegionOverlay = () => {
  const BaseOverlay = createBaseOverlay()

  const RegionOverlay = createOverlay<RegionOverlay, RegionOverlayOptions>({
    base: BaseOverlay,
  })

  return RegionOverlay
}
